import React from 'react';
import {makeStyles, Container, Grid, Paper} from '@material-ui/core';
import LeaveForm from './component/Form'
import Balance from './component/Balance'
import RecentLeave from './component/RecentLeave'
import RecentLeaveCollection from '../Function/RecentLeaveCollection'
import CompLeaveCollection from '../Function/CompLeaveCollection'
import customAxios from "../API/customAxios";
import {useIntl} from 'react-intl';
import MiniTable from "../UIComponent/MiniTable";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
    },
    subPaper: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
}));

export default function LeaveApplication() {
    const mode = window.global.submitMode;
    const classes = useStyles();
    const intl = useIntl();
    const [userData, setUserData] = React.useState({
        employee_name: null,
        staff_duty: null,
        user_role: null,
        annual_allowances: null,
        annual_total: null,
    });
    const [rows, setRows] = React.useState([]);
    const [compLeaveRows, setCompLeaveRows] = React.useState([]);

    React.useEffect(() => {
        customAxios.get('/get_user_record')
            .then(res => {
                setUserData(res.data);
                setCompLeaveRows(CompLeaveCollection(res.data['comp_leave_balance'], intl));
                setRows(RecentLeaveCollection(res.data['recent_leave'], intl));
            });
    }, []);

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer}/>
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={7}>
                        <Paper className={classes.mainPaper}>
                            <LeaveForm
                                mode={mode}
                                employeeId={userData.id}
                                employeeName={userData.employee_name}
                                staffDuty={userData.staff_duty}
                                annualAllowances={userData.annual_allowances}
                                annualTotal={userData.annual_total}
                                compLeaveRows={compLeaveRows}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12} lg={5}>
                        <Paper className={classes.mainPaper}>
                            <Balance mode={mode} annualAllowances={userData.annual_allowances}/>
                        </Paper>
                        {userData.staff_duty == 'OFFICE HOURS' ? (
                            <Paper className={classes.subPaper}>
                                <MiniTable rows={compLeaveRows} />
                            </Paper>
                        ) : ''}
                        <Paper className={classes.subPaper}>
                            <RecentLeave rows={rows}/>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </main>
    );
}
